"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.FdrPicture = void 0;
const react_1 = __importDefault(require("react"));
const fdr_picture_utils_1 = require("./fdr-picture.utils");
function FdrPicture({ sources, sizes, children }) {
    // Conditionally sort if there are IDs conforming to the pixel ratio number pattern
    const processedSizes = sizes.some(size => !Number.isNaN((0, fdr_picture_utils_1.extractPixelRatioNumber)(size.id)))
        ? [...sizes].sort((a, b) => (0, fdr_picture_utils_1.extractPixelRatioNumber)(b.id) - (0, fdr_picture_utils_1.extractPixelRatioNumber)(a.id)) // Sort in descending order, so that 2x comes before 1x. This ensures that the browser doesn't choose a lower resolution image first
        : sizes; // Leave unsorted if the pattern doesn't match
    return (react_1.default.createElement("picture", null,
        processedSizes.map(i => {
            const media = (0, fdr_picture_utils_1.getMediaQuery)(sources.get(i.id), i.id);
            return react_1.default.createElement("source", { key: i.id, srcSet: i.link.url, media: media });
        }),
        children));
}
exports.FdrPicture = FdrPicture;
//# sourceMappingURL=fdr-picture.js.map